import clsx from 'clsx';
import React from 'react';

var TUXSeparator = function TUXSeparator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LinePrimary' : _ref$color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction;
  return /*#__PURE__*/React.createElement("div", {
    role: "separator",
    className: clsx('flex flex-shrink-0 box-border', {
      'horizontal': 'tux-separator--horizontal',
      'vertical': 'tux-separator--vertical'
    }[direction], {
      'large': 'tux-separator--large',
      'medium': 'tux-separator--medium'
    }[size], {
      'BGView': 'background-color-BGView',
      'LinePrimary': 'background-color-LinePrimary',
      'LinePrimary2': 'background-color-LinePrimary2',
      'LineSecondary': 'background-color-LineSecondary',
      'LineSecondary2': 'background-color-LineSecondary2',
      'ConstLineInverse': 'background-color-ConstLineInverse',
      'ConstLineInverse2': 'background-color-ConstLineInverse2'
    }[color])
  });
};

export { TUXSeparator };
//# sourceMappingURL=TUXSeparator.js.map
